import { FC } from 'react';
import { Box, useTheme } from '@mui/material';
import ModalDialog from '../../../../../common/components/ModalDialog';
import { PolicyFix } from '../../../types/issues-types';
import PolicyFixContainer from './PolicyFixContainer';

const PolicyFixModal: FC<
  React.PropsWithChildren<PolicyFixModalProps>
> = props => {
  const theme = useTheme();
  const { open, onClose, fix } = props;

  return (
    <ModalDialog
      sx={{ maxHeight: 1000 }}
      maxWidth='md'
      modalColor={theme.palette.info.main}
      aria-label='Fix'
      open={open}
      onClose={onClose}
      modalHeader='Fix'>
      <Box display='flex' flexDirection='column'>
        <PolicyFixContainer
          onClose={onClose}
          settingType={fix.settingType}
          inputs={fix.inputs}
          description={fix.description}
          warning={fix.warning}
          confirmation={fix.confirmation}
        />
      </Box>
    </ModalDialog>
  );
};

export interface PolicyFixModalProps {
  open: boolean;
  onClose: () => void;
  fix: PolicyFix;
}

export default PolicyFixModal;
